<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label required">{{
          $t('thesisTopic.code')
        }}</label>
        <input
          type="text"
          class="form-control"
          v-model="model.topic_code"
          :placeholder="$t('thesisTopic.enterTopicCode')"
          :class="{ 'is-invalid': errors.has('topic_code') }"
          disabled
        />
        <div class="invalid-feedback" v-if="errors.has('topic_code')">
          {{ errors.first('topic_code') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('thesisTopic.nameKh') }}</label>
        <input
          v-model="model.topic_name_kh"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('topic_name_kh') }"
        />
        <div class="invalid-feedback" v-if="errors.has('topic_name_kh')">
          {{ errors.first('topic_name_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label required">{{
          $t('thesisTopic.nameEn')
        }}</label>
        <input
          v-model="model.topic_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('topic_name_en') }"
        />
        <div class="invalid-feedback" v-if="errors.has('topic_name_en')">
          {{ errors.first('topic_name_en') }}
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required">{{ $t('thesisTopic.acYear') }}</label>
          <a-select
            v-model="model.ac_year_id"
            :options="ac_year_list"
            @change="acYearChange"
            :class="{
              'is-invalid': errors.has('ac_year_id')
            }"
          ></a-select>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required">{{ $t('thesisTopic.subProgram') }}</label>
          <a-select
            style="width: 100%"
            v-model="model.acps_id"
            :options="sub_programs"
            :show-search="true"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="onSubChange"
            :disabled="!model.ac_year_id"
          >
          </a-select>
        </div>
      </div>
      <div class="form-group">
        <label class="required">{{ $t('thesisTopic.degree') }}</label>
        <ts-loading-banner :loading="filterSub">
          <a-select
            style="width: 100%"
            v-model="model.level_id"
            :class="{
              'is-invalid': errors.has('level_id')
            }"
            :options="levels"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="levelChange"
          ></a-select>
        </ts-loading-banner>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required">{{ $t('thesisTopic.acTerm') }}</label>
          <ts-loading-banner :loading="filterLevel">
            <a-select
              style="width: 100%"
              v-model="model.ac_term_id"
              :options="ac_terms"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              @change="acTermChange"
            ></a-select>
          </ts-loading-banner>
          <div class="validate" v-if="errors.has('ac_term_id')">
            {{ errors.first('ac_term_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label>{{ $t('thesisTopic.classOperation') }}</label>
          <ts-loading-banner :loading="filterClass">
            <a-select
              style="width: 100%"
              v-model="model.class_id"
              :options="class_options"
            ></a-select>
          </ts-loading-banner>
          <div class="validate" v-if="errors.has('class_id')">
            {{ errors.first('class_id') }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('thesisTopic.description') }}</label>
        <textarea
          rows="5"
          class="form-control"
          v-model="model.remarks"
        ></textarea>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="updating == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          v-if="!updating"
          :waiting="waiting"
          class="btn btn-primary ml-2"
          @click.prevent="save"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="updating"
          @click="update"
          :waiting="waiting"
          class="btn btn-primary ml-2"
          >{{ $t('Update') }}</ts-button
        >
      </div>
    </form>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'thesis-topic-create',
  data () {
    return {
      errors: new Errors(),
      saving: false,
      editing: false,
      waiting: false,
      updating: false,
      filterSub: false,
      filterClass: false,
      filterLevel: false,
      levels: [],
      ac_year_list: [],
      sub_programs: [],
      ac_terms: [],
      class_options: [],
      model: {
        topic_id: null,
        topic_name_kh: null,
        topic_name_en: null,
        level_id: null,
        remarks: null,
        topic_code: null,
        ac_year_id: null,
        acps_id: null,
        ac_term_id: null,
        class_id: null
      }
    }
  },
  created () {
    this.fetchResource()
  },
  computed: {
    ...mapState('thesisTopic', ['edit_data'])
  },
  methods: {
    ...mapActions('thesisTopic', [
      'getLevel',
      'getYear',
      'getSubProgram',
      'getClass',
      'getTerm'
    ]),
    async fetchResource () {
      await this.getYear()
        .then(response => {
          this.ac_year_list = response.data.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.getSubProgram().then(response => {
        this.sub_programs = response.data.map(el => ({
          value: el.acps_id,
          label: el.acps_name_foreign
        }))
      })
      this.setEditData()
    },
    acYearChange () {
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.level_id = null
      this.model.class_id = []
    },
    async save () {
      this.waiting = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'thesisTopic/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.waiting = false
    },
    async onSubChange (acps_id) {
      this.model.level_id = []
      this.model.class_id = []
      this.levels = []
      this.filterSub = true
      await this.getLevel({
        filter: {
          acps_id: acps_id
        }
      })
        .then(response => {
          this.levels = response.data.map(el => ({
            value: el.level_id,
            label: el.level_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterSub = false
        })
    },
    async levelChange (level_id) {
      this.filterLevel = true
      this.model.ac_term_id = null
      await this.getTerm({
        filter: {
          level_id: level_id
        }
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : null)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterLevel = false
        })
    },
    acTermChange (ac_term_id) {
      this.model.class_id = []
      this.filterClass = true
      this.getClass({
        filter: {
          ac_term_id: ac_term_id
        }
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label: el.class_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterClass = false
        })
    },
    async update () {
      this.waiting = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'thesisTopic/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'thesis-topic' })
        this.updating = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.updating = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.waiting = false
    },
    async setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.updating = true
        await this.getLevel({
          filter: {
            acps_id: this.edit_data.level.acps_id
          }
        })
          .then(response => {
            this.levels = response.data.map(el => ({
              value: el.level_id,
              label: el.level_name_foreign
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.filterSub = false
          })

        await this.getTerm({
          filter: {
            acps_id: this.edit_data.level.acps_id
          }
        })
          .then(response => {
            this.ac_terms = response.data.map(el => ({
              value: el.ac_term_id,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : null)
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.filterLevel = false
          })

        await this.getClass({
          filter: {
            ac_term_id: this.edit_data.level.ac_term_id
          }
        }).then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label: el.class_name
          }))
        })
        this.model.topic_id = this.edit_data.topic_id
        this.model.topic_code = this.edit_data.topic_code
        this.model.topic_name_kh = this.edit_data.topic_name_kh
        this.model.topic_name_en = this.edit_data.topic_name_en
        this.model.ac_year_id = this.edit_data.level.ac_year_id
        this.model.acps_id = this.edit_data.level.acps_id
        this.model.level_id = this.edit_data.level.level_id
        this.model.ac_term_id = this.edit_data.level.ac_term_id
        this.model.class_id = this.edit_data.level.class_id
      }
    },
    cancel () {
      this.updating = false
      this.$router.push({ name: 'thesis-topic' })
      this.clearForm()
      this.$emit('cancel')
    },
    clearForm () {
      this.model.topic_name_kh = null
      this.model.topic_name_en = null
      this.model.level_id = null
      this.model.remarks = null
      ;(this.model.topic_code = null),
        (this.model.class_id = []),
        (this.model.ac_term_id = null),
        (this.model.ac_year_id = null),
        (this.model.acps_id = null)
    }
  },
  watch: {
    edit_data: {
      handler () {
        if (!_.isEmpty(this.edit_data)) {
          this.setEditData()
        }
      },
      deep: true
    }
  }
}
</script>
